import React from 'react'
import { connect } from 'react-redux'
import { Layout } from 'antd'
import { withRouter } from 'react-router-dom'
import classNames from 'classnames'
import CreateApplication from 'pages/app/create-application'
import LoginForm from '../../components/auth/Login/loginForm'
import LoginOTPForm from '../../components/auth/LoginOTP/loginOTPForm'
import SignupForm from '../../components/auth/Signup/signupForm'
import SSOForm from '../../components/auth/Login/ssoForm'
import ForgotPasswordForm from '../../components/auth/ResetPassword/forgotPasswordForm'
import ResetPasswordEmailSent from '../../components/auth/ResetPassword/resetPasswordEmailSent'
import VerificationEmailSent from '../../components/auth/VerificationEmailSent'
import Welcome from '../../components/auth/Welcome'
import ResetPasswordForm from '../../components/auth/ResetPassword'
import AcceptCollboratorInvitation from '../../components/auth/AcceptCollboratorInvitation'
import HeaderBranding from '../../components/layout/HeaderBranding'
import RightHandSideContainer from '../../components/layout/RightHandSideContainer'
import FooterAuth from '../../components/layout/FooterAuth'
import ScheduleKickOffCall from '../../components/auth/ScheduleKickOffCall'
import NotificationComponent from '../../components/design/Form/Notifications'
import LinkPurple from '../../components/design/Form/LinkPurple'
import style from './style.module.scss'

const mapStateToProps = ({ settings, user }) => ({ settings, user })

@connect(mapStateToProps)
@withRouter
class AuthLayout extends React.PureComponent {
  state = { userAuthInProgress: false, userAuthenticated: false }

  componentDidUpdate() {
    const { userAuthInProgress, userAuthenticated } = this.state
    if (!userAuthInProgress && !userAuthenticated) {
      this.updateAuthInProgress()
      const { dispatch } = this.props
      dispatch({
        type: 'user/AUTHENTICATE_IF_USER_ALREADY_IN_SESSION',
        payload: [],
      })
    }
  }

  updateAuthInProgress = () => {
    this.setState({ userAuthInProgress: true, userAuthenticated: true })
  }

  render() {
    let onboardingStep = true
    const v2AuthContainerClasses = `${style.v2AuthContainer} row`
    const pageTitleMainClassesXLView = `${style.pageTitleMain} col-md-12 col-xl-12 col-sm-12 col-xs-12 mobile-hide`
    const pageTitleMainClassesXSView = `${style.pageTitleMain} col-md-12 col-xl-12 col-sm-12 col-xs-12 ml-0 mobile-show`
    const { location, settings, user } = this.props
    let formComponent = (
      <React.Fragment>
        <LoginForm />
      </React.Fragment>
    )

    if (location.pathname === '/verify-account') {
      formComponent = (
        <React.Fragment>
          <LoginOTPForm
            headerTitle={
              <React.Fragment>
                <h2 className={pageTitleMainClassesXLView}>Verify Your Email</h2>
                <h2 className={pageTitleMainClassesXSView}>Verify Email</h2>
              </React.Fragment>
            }
          />
        </React.Fragment>
      )
    } else if (location.pathname === '/signup' || location.pathname === '/register') {
      formComponent = (
        <React.Fragment>
          <SignupForm />
        </React.Fragment>
      )
    } else if (location.pathname === '/forgot-password') {
      onboardingStep = false

      formComponent = (
        <React.Fragment>
          <ForgotPasswordForm />
        </React.Fragment>
      )
    } else if (location.pathname === '/reset-password-email-sent') {
      onboardingStep = false

      formComponent = (
        <React.Fragment>
          <ResetPasswordEmailSent
            headerTitle={
              <React.Fragment>
                <h2 className={pageTitleMainClassesXLView}>Reset Password</h2>
                <h2 className={pageTitleMainClassesXSView}>Reset Password</h2>
              </React.Fragment>
            }
            subTitle={
              <React.Fragment>
                <h3 className={style.formConfirmationMessage}>Reset password email sent</h3>
              </React.Fragment>
            }
          />
        </React.Fragment>
      )
    } else if (location.pathname.indexOf('/reset/password/') >= 0) {
      onboardingStep = false
      const footerClasses = `${style.authFooterWrapper} ${style.stickyCenterForm}`
      formComponent = (
        <React.Fragment>
          <ResetPasswordForm
            headerTitle={
              <React.Fragment>
                <h2 className={pageTitleMainClassesXLView}>Reset Password</h2>
                <h2 className={pageTitleMainClassesXSView}>Reset Password</h2>
              </React.Fragment>
            }
            footer={
              <Layout.Footer className={footerClasses}>
                <FooterAuth footerCopyRightClasses={style.footerCopyrightText} />
              </Layout.Footer>
            }
          />
        </React.Fragment>
      )
    } else if (location.pathname.indexOf('/invite/collaborator/') >= 0) {
      onboardingStep = false
      formComponent = (
        <React.Fragment>
          <AcceptCollboratorInvitation />
        </React.Fragment>
      )
    } else if (location.pathname === '/verification-email-sent') {
      formComponent = (
        <React.Fragment>
          <VerificationEmailSent
            subTitle={
              <>
                We’ve sent an email to {location.search.split('email=')[1]} with a link to complete
                your account setup
              </>
            }
          />
        </React.Fragment>
      )
    } else if (
      location.pathname.includes('/verify/email/') &&
      location.pathname.split('/verify/email/').length >= 2
    ) {
      const footerClasses = `${style.authFooterWrapper} ${style.stickyCenterForm}`
      formComponent = (
        <React.Fragment>
          <Welcome
            headerTitle={
              <React.Fragment>
                <h2 className={pageTitleMainClassesXLView}>Verify your email</h2>
                <h2 className={pageTitleMainClassesXSView}>Verify your email</h2>
              </React.Fragment>
            }
            subTitle={
              <>
                Just click on the temporary login link we sent to your email. <br /> If you do not
                receive it right away, please check your spam folder. <br />
                <div style={{ display: 'flex' }}>
                  If you wish to change your email click &nbsp;{' '}
                  <LinkPurple
                    linkHolderStyles={{ marginTop: '4.5px' }}
                    to="/signup"
                    linktext="here"
                  />
                  .
                </div>
              </>
            }
            footer={
              <Layout.Footer className={footerClasses}>
                <FooterAuth footerCopyRightClasses={style.footerCopyrightText} />
              </Layout.Footer>
            }
            userEmail={user.signupEmail}
          />
        </React.Fragment>
      )
    } else if (location.pathname === '/create-your-first-application') {
      formComponent = <CreateApplication />
    } else if (location.pathname === '/schedule-your-kick-off-call') {
      formComponent = (
        <React.Fragment>
          <ScheduleKickOffCall />
        </React.Fragment>
      )
    } else if (location.pathname === '/sso-complete') {
      onboardingStep = false
      formComponent = (
        <React.Fragment>
          <SSOForm
            headerTitle={
              <React.Fragment>
                <h2 className={pageTitleMainClassesXLView}>Complete Your Registration</h2>
                <h2 className={pageTitleMainClassesXSView}>Complete Registration</h2>
              </React.Fragment>
            }
            footer={
              !settings.isTabletView && (
                <Layout.Footer className={style.authFooterWrapper}>
                  <FooterAuth footerCopyRightClasses={style.footerCopyrightText} />
                </Layout.Footer>
              )
            }
          />
          <RightHandSideContainer />
          {settings.isTabletView && (
            <Layout.Footer className={style.authFooterWrapper}>
              <FooterAuth footerCopyRightClasses={style.footerCopyrightText} />
            </Layout.Footer>
          )}
        </React.Fragment>
      )
    }

    return (
      <Layout style={{ background: '#ffffff' }}>
        <Layout.Content style={{ background: '#ffffff' }}>
          <div className={classNames(style.container, onboardingStep ? 'showBgImg' : '')}>
            {location.pathname === '/create-your-first-application' ||
            location.pathname === '/schedule-your-kick-off-call' ||
            location.pathname.includes('/choose-role') ||
            location.pathname.includes('/verify/email/') ? (
              <>{formComponent}</>
            ) : (
              <div
                className={v2AuthContainerClasses}
                style={{ width: '100%', padding: '32px 0px 0px 32px' }}
              >
                <HeaderBranding
                  showLogo={location.pathname.indexOf('/invite/collaborator/') >= 0}
                  borderLess
                  inAuthLoginCheck={
                    location.pathname.indexOf('/invite/collaborator/') >= 0 ||
                    location.pathname === '/create-your-first-application'
                  }
                />
                {formComponent}
                <NotificationComponent />
              </div>
            )}
          </div>
        </Layout.Content>
      </Layout>
    )
  }
}

export default AuthLayout
